import type { WidgetTheme } from '../../types/theme';

/** Возвращает и переопределяет цветовую схему в зависимости от переданного пресета */
export const getThemeConfig = (widgetTheme: WidgetTheme) => {
  return {
    light: widgetTheme,
  };
};
